<div class="container">
  <div class="user-list mt-3 mb-3" *ngIf="bookingPrices.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col" class="text-center">#</th>
        <th scope="col" class="text-center">Office</th>
        <th scope="col" class="text-center">Room</th>
        <th scope="col" class="text-center">Option</th>
        <th scope="col" class="text-center">Time Period</th>
        <th scope="col" class="text-center">Price</th>
        <th scope="col" class="text-center">Currency</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let bookingPrice of bookingPrices">
        <td class="text-center">{{ bookingPrice.id }}</td>
        <td class="text-center">{{ getOffice(bookingPrice.officeId) }}</td>
        <td class="text-center">{{ getRoom(bookingPrice.roomId) }}</td>
        <td class="text-center">{{ bookingPrice.bookingOption }}</td>
        <td class="text-center">{{ bookingPrice.timePeriod.name }}</td>
        <td class="text-center">{{ bookingPrice.price }}</td>
        <td class="text-center">{{ bookingPrice.currency }}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(bookingPrice)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(bookingPrice)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="user-list mt-3 mb-3" *ngIf="bookingPrices.length == 0">
    <p>You have no booking prices yet</p>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
